import {JoinObject, LeaveObject, TypingObject} from "../../types/chat";
import UserData from "../user/UserData";
import {AgentEvent} from "../../types/enums";

export class EventFactory {
    static createJoin(
        trademark: string,
        chatType: string,
        chatSessionId: string,
        userData: null|UserData,
    ): JoinObject {
        return {
            class: AgentEvent.JOIN,
            type: 'Event',
            chatSessionId: chatSessionId,
            chatType: chatType,
            trademark: trademark,
            customerFirstName: userData !== null ? userData.getUserFirstName() : '',
            customerLastName: userData !== null ? userData.getUserLastName() : ''
        }
    }

    static createLeave(
    ): LeaveObject {
        return {
            class: AgentEvent.LEAVE,
            type: 'Event',
            originatingEntity: 'Human',
        }
    }

    static createTyping(
    ): TypingObject {
        return {
            class: AgentEvent.TYPING,
            type: 'Event',
        };
    }
}